import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { TransactionType, TransactionTypeStatus } from 'dashboard/models/transaction-type';
import { dashboardApi, LIST_TAG_ID } from 'dashboard/redux/api/api';
import { ApiOptions } from 'lib/clients/ApiClient';
import {
  ApiEndpoint,
  ApiListResponse,
  ApiModel,
  ApiResponse,
  PaginationParams,
} from 'lib/interfaces/api';

interface CreateTransactionTypeValues {
  name: string;
  environmentId: string;
}

export const transactionTypesApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    listTransactionTypes: builder.query<ApiListResponse<TransactionType>, ApiOptions>({
      query: (options) => {
        return SessionClientDashboard.listResource<TransactionType, PaginationParams>(
          ApiEndpoint.TransactionType,
          {
            filter: {
              omni: null,
              status: [TransactionTypeStatus.Active, TransactionTypeStatus.Inactive],
            },
            page: { size: 100 },
            ...options,
          },
        );
      },
      providesTags: (_result, _error) => {
        return [{ type: ApiModel.TransactionType, id: LIST_TAG_ID }];
      },
    }),
    createTransactionType: builder.mutation<
      ApiResponse<TransactionType>,
      CreateTransactionTypeValues
    >({
      query: async ({ name, environmentId }) => {
        const payload = {
          attributes: {
            name,
            'environment-id': environmentId,
          },
          type: ApiModel.TransactionType as const,
        };
        return SessionClientDashboard.postResourceCreate<TransactionType>(payload);
      },
      invalidatesTags: (_result, _error) => {
        return [{ type: ApiModel.TransactionType, id: LIST_TAG_ID }];
      },
    }),
    activateTransactionType: builder.mutation<ApiResponse<TransactionType>, string>({
      query: async (transactionTypeId) => {
        return SessionClientDashboard.postResourceAction<
          TransactionType,
          { type: ApiModel.TransactionType; id: string }
        >(
          {
            type: ApiModel.TransactionType,
            id: transactionTypeId,
          },
          'activate',
        );
      },
      invalidatesTags: (_result, _error, transactionTypeId) => {
        return [
          { type: ApiModel.TransactionType, id: LIST_TAG_ID },
          { type: ApiModel.TransactionType, id: transactionTypeId },
        ];
      },
    }),
    deactivateTransactionType: builder.mutation<ApiResponse<TransactionType>, string>({
      query: async (transactionTypeId) => {
        return SessionClientDashboard.postResourceAction<
          TransactionType,
          { type: ApiModel.TransactionType; id: string }
        >(
          {
            type: ApiModel.TransactionType,
            id: transactionTypeId,
          },
          'deactivate',
        );
      },
      invalidatesTags: (_result, _error, transactionTypeId) => {
        return [
          { type: ApiModel.TransactionType, id: LIST_TAG_ID },
          { type: ApiModel.TransactionType, id: transactionTypeId },
        ];
      },
    }),
  }),
});

// Hooks are autogenerated based on the defined endpoints
export const {
  useListTransactionTypesQuery,
  useCreateTransactionTypeMutation,
  useActivateTransactionTypeMutation,
  useDeactivateTransactionTypeMutation,
} = transactionTypesApi;
